
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Link, Image } from '@ta-interaktiv/contentbricks'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>
  Der Aufenthalt in einer kleinen, geschlossenen Umgebung wie dem Innenraum
  eines Autos kann zu einem hohen Infektionsrisiko führen, wenn der Mitfahrer
  mit Sars-CoV-2 infiziert ist. Das Risiko kann erheblich verringert werden,
  wenn alle Mitfahrer eine Maske tragen und wenn während der Fahrt zwei Fenster
  zumindest teilweise geöffnet sind. Ist das Belüftungssystem in Betrieb, sollte
  sichergestellt werden, dass es auf Aussenluft eingestellt ist und nicht auf
  Umluft, da sich sonst ausgeatmete Luft ansammelt. Da die Expositionszeit
  wichtig ist, sind kürzere Reisen besser als längere.
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;